/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import { Modal, Button } from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import HideIf from 'loracoms/HideIf';
import IntlMsg from 'lorautils/intl/IntlMsg';

const defaultProps = {
  show: false,
  onHide: () => {},
  plan: {},
};

const propTypes = {
  onHide: React.PropTypes.func,
  show: React.PropTypes.bool,
  plan: React.PropTypes.object,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.object.isRequired,
};

class DeviceOOQModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      plan: props.plan,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.detailview.devicelist');
  }

  componentWillReceiveProps(nextProps) {
    const { show, plan } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  render() {
    const { onHide, pushState } = this.props;
    const { show, plan = {} } = this.state;
    const { data: { tier = 3 } = {} } = plan;

    return (
      <Modal
        bsClass="aisz-modal-warning"
        show={show}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" />
            {' '}
            {this.intlMsg.msg('adderr.header')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <HideIf if="profile:cube">
            <ShowIf if={tier < 3}>
              <div className="text-center">
                <p> { this.intlMsg.msg('adderr.ooq.undercomm') } </p>
                <Button
                  bsStyle="aisz-primary-o"
                  bsSize="small"
                  onClick={() => pushState('/billing/plans')}
                >
                  {this.intlMsg.msg('adderr.upgrade.btn')}{' '}
                  <i className="fa fa-arrow-circle-o-right" />
                </Button>
              </div>
            </ShowIf>
          </HideIf>
          <HideIf if="profile:cube">
            <ShowIf if={tier === 3}>
              <div className="text-center">
                <p>
                  { this.intlMsg.msg('adderr.ooq.comm') }
                </p>
                <a href="mailto:support@aisenz.com">support@aisenz.com</a>
              </div>
            </ShowIf>
          </HideIf>
          <ShowIf if="profile:cube">
            <div className="text-center">
              <p>
                {this.intlMsg.msg('adderr.ooq.cube')}
              </p>
              <a href="mailto:support@aisenz.com">support@aisenz.com</a>
            </div>
          </ShowIf>
        </Modal.Body>
      </Modal>
    );
  }
}

DeviceOOQModal.defaultProps = defaultProps;
DeviceOOQModal.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DeviceOOQModal));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/DeviceOOQModal/index.jsx